// src/components/Blocks/CardList/Edit.jsx
import React, { useEffect } from 'react';
import { SidebarPortal } from '@plone/volto/components';
import { useDispatch, useSelector } from 'react-redux';
import { searchContent } from '@plone/volto/actions';
import CardListData from './Data';
import CardListView from './View';
import { withBlockExtensions } from '@plone/volto/helpers';
import { injectIntl } from 'react-intl';

const CardListEdit = (props) => {
  const { data, onChangeBlock, block, selected, intl, blocksConfig } = props;
  const { contentType, totalResults = 10, resultsPerPage = 4, sortOrder = 'created|desc' } = data;

  const dispatch = useDispatch();
  const searchResults = useSelector((state) => {
    const items = state.search.subrequests[block]?.items;
    return items !== undefined ? items : []; // Evita di creare un nuovo array ogni volta
  });

  const [sortOn, sortOrderDirection] = sortOrder.split('|');
  const query = {
    portal_type: contentType || 'News Item',
    metadata_fields: ['created', 'effective', 'modified', 'title', 'description', 'image_field'],
    fullobjects: 1,
    sort_on: sortOn,
    sort_order: sortOrderDirection,
    b_size: totalResults,
  };

  useEffect(() => {
    
    dispatch(searchContent('/', query, block));
  }, [dispatch, block, contentType, totalResults, sortOrder]);

  useEffect(() => {
    if (searchResults.length > 0) {
      // Crea nuovi items solo se necessari
      const newItems = searchResults.map(item => ({
        ...item, // Mantieni TUTTE le proprietà originali
        created: item.created, // Aggiungi esplicitamente i campi data
        modified: item.modified,
        effective: item.effective
      }));
  
      if (JSON.stringify(data.items) !== JSON.stringify(newItems)) {
        onChangeBlock(block, {
          ...data,
          items: newItems
        });
      }
    }
  }, [searchResults, block, onChangeBlock, data]);

  const displayedItems = searchResults.slice(0, resultsPerPage);

  return (
    <>
      <CardListView {...props} items={displayedItems} />
      <SidebarPortal selected={selected}>
        <CardListData
          key={block}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
          blocksConfig={blocksConfig}
          intl={intl}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(injectIntl(CardListEdit));